import PropTypes from "prop-types";
import { Dialog, Zoom, styled } from "@mui/material";

export const EDITOR_DIALOG_PAPER_SX = {
  borderRadius: "16px",
  boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
};

const StyledEditorDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    ...EDITOR_DIALOG_PAPER_SX,
    padding: theme.spacing(2),
  },
}));

const EditorDialog = ({ children, paperSx, slots, slotProps, ...props }) => (
  <StyledEditorDialog
    slots={{ transition: Zoom, ...slots }}
    slotProps={{
      ...slotProps,
      paper: {
        ...slotProps?.paper,
        sx: { ...EDITOR_DIALOG_PAPER_SX, ...paperSx, ...slotProps?.paper?.sx },
      },
    }}
    {...props}
  >
    {children}
  </StyledEditorDialog>
);

EditorDialog.propTypes = {
  children: PropTypes.node,
  paperSx: PropTypes.object,
  slots: PropTypes.object,
};

export default EditorDialog;
 